import { useRef, useEffect, useState } from "react";
import "./CustomerReviews.css";
import crBg from "../../assets/cr_bg_dark.png";

const reviews = [
  {
    name: "Sarah M.",
    suburb: "Frankston, VIC",
    stars: 5,
    text: "From the first call to the final install, everything was smooth and professional. They explained every step clearly and the system has been running perfectly. Couldn't be happier.",
  },
  {
    name: "James T.",
    suburb: "Dandenong, VIC",
    stars: 5,
    text: "We got three quotes and Watt & Wattle were by far the most honest about what we actually needed. No upselling, no pressure. Our bills dropped by almost half in the first month.",
  },
  {
    name: "Linda K.",
    suburb: "Pakenham, VIC",
    stars: 5,
    text: "The team was fantastic — on time, tidy, and knew exactly what they were doing. They followed up a week after install to make sure everything was working as expected. Really appreciated that.",
  },
  {
    name: "David R.",
    suburb: "Berwick, VIC",
    stars: 5,
    text: "Highly recommend. Qualified installers, quality panels, and they handled all the paperwork with the grid. The process was genuinely stress-free from start to finish.",
  },
];

function Stars({ count }) {
  return (
    <div className="cr-stars">
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="16" height="16" viewBox="0 0 16 16" fill="#eaff50">
          <path d="M8 1l1.85 3.75L14 5.5l-3 2.92.71 4.14L8 10.5l-3.71 1.96L5 8.42 2 5.5l4.15-.75z" />
        </svg>
      ))}
    </div>
  );
}

export default function CustomerReviews() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={`cr-section ${inView ? "cr-in-view" : ""}`} style={{ backgroundImage: `url(${crBg})` }}>
      <div className="cr-inner">

        {/* Header */}
        <div className="cr-header">
          <span className="cr-label">Customer Reviews</span>
          <h2 className="cr-title">What Our Customers Say</h2>
          <p className="cr-subtitle">Real feedback from homeowners across Melbourne</p>
          <div className="cr-aggregate">
            <div className="cr-agg-stars">
              {Array.from({ length: 5 }).map((_, i) => (
                <svg key={i} width="20" height="20" viewBox="0 0 16 16" fill="#eaff50">
                  <path d="M8 1l1.85 3.75L14 5.5l-3 2.92.71 4.14L8 10.5l-3.71 1.96L5 8.42 2 5.5l4.15-.75z" />
                </svg>
              ))}
            </div>
            <span className="cr-agg-score">5.0</span>
            <span className="cr-agg-count">from customer reviews</span>
          </div>
        </div>

        {/* Cards */}
        <div className="cr-grid">
          {reviews.map((r, i) => (
            <div className="cr-card" key={i}>
              <div className="cr-quote-mark">"</div>
              <p className="cr-text">{r.text}</p>
              <div className="cr-footer">
                <Stars count={r.stars} />
                <div className="cr-author">
                  <span className="cr-name">{r.name}</span>
                  <span className="cr-suburb">{r.suburb}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
